import React, { useCallback } from 'react';
import {
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  Label,
  OptionKey,
  Text,
  Toggle,
  useFormContext,
} from '@common-fe/common-fe';

import { ERROR_ELEMENT_SCROLL_CLASS_NAME } from '@/common/constants';

import { ADD_CONTACT_ID, EDIT_CONTACT_ID, IPermission, IRoleSetup, VIEW_CONTACT_ID } from '../../role.types';

import AllowContactCreateRole from './AllowContactCreateRole';

interface Props extends IPermission {
  isEditMode?: boolean;
  isDisabled?: boolean;
}


const PermissionToggleField: React.FC<Props> = ({
  isEditMode = false,
  isAlwaysOn,
  group: id,
  name,
  isDisabled,
  description,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IRoleSetup>();

  const handleToggle = useCallback(
    (values: OptionKey[], callback: (values: OptionKey[]) => void) => (newValue: boolean) => {
      if (newValue) {
        callback([...values, id]);
      } else {
        const filteredList = values.filter((currentValue) => currentValue !== id);
        callback(filteredList);
      }
    },
    [id]
  );
  const handleCheckAlwaysOn = useCallback(
    (values: OptionKey[], callback: (values: OptionKey[]) => void) => {
      if(isDisabled) {
        return;
      }
      if (!isAlwaysOn) {
        return;
      }

      if (!values.includes(id)) {
        callback([...values, id]);
      }
    },
    [id, isAlwaysOn, isDisabled]
  );

  return (
    <Box direction="column">
      {ADD_CONTACT_ID === id && <Box height="1px" background="border1" margin={{ bottom: 'm' }} />}
      <FieldWrapper align="start" className={errors?.permissions?.message ? ERROR_ELEMENT_SCROLL_CLASS_NAME : ''}>
        <Box direction="row" height={{ min: '40px' }} align={description ? 'start' : 'center'}>
          <Box direction="column" width={{ max: '300px' }}>
            <Label name="roleName">{name}</Label>
            <Text size="small" color="textSecondary" style={{ lineHeight: '18px' }}>
              {description}
            </Text>
          </Box>
          <ControllerWrapper  errorText={isAlwaysOn ? '' : errors?.permissions?.message}>
            <Controller
              name="permissions"
              control={control}
              render={({ field }) => {
                handleCheckAlwaysOn(field.value, field.onChange);
                return (
                  <Box>
                    <Toggle
                      testId="role_permission"
                      name={`${id || ''}`}
                      disabled={isAlwaysOn || isDisabled}
                      value={isDisabled ? false :  field.value?.includes(id) || !!isAlwaysOn}
                      onChange={handleToggle(field.value, field.onChange)}
                    />
                  </Box>
                );
              }}
            />
          </ControllerWrapper>
        </Box>
      </FieldWrapper>


      {id === EDIT_CONTACT_ID && <AllowContactCreateRole isEditMode={isEditMode} />}

      {VIEW_CONTACT_ID === id && <Box height="1px" background="border1" margin={{ top: 'm' }} />}
    </Box>
  );
};

export default PermissionToggleField;
